var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinimize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 18,
    viewBox: "0 0 9 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333339 8.99995C0.332806 8.72735 0.427743 8.46318 0.601671 8.25328L6.435 1.25328C6.63303 1.01503 6.9176 0.865197 7.22609 0.836754C7.53459 0.808311 7.84175 0.903584 8.08 1.10161C8.31826 1.29964 8.46809 1.5842 8.49653 1.8927C8.52497 2.2012 8.4297 2.50836 8.23167 2.74661L3.005 8.99995L8.045 15.2533C8.14191 15.3726 8.21428 15.5099 8.25795 15.6573C8.30162 15.8047 8.31573 15.9593 8.29947 16.1122C8.28321 16.265 8.2369 16.4132 8.16319 16.5481C8.08949 16.683 7.98985 16.802 7.87 16.8983C7.75005 17.0051 7.60931 17.086 7.45663 17.136C7.30394 17.1859 7.14259 17.2037 6.98269 17.1884C6.82278 17.1731 6.66776 17.1249 6.52734 17.0469C6.38693 16.9688 6.26414 16.8626 6.16667 16.7349L0.531672 9.73495C0.385237 9.51902 0.315406 9.26023 0.333339 8.99995Z",
    fill: "#8E8EA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimize);
export default __webpack_public_path__ + "static/media/minimize.38fb2d3d11e3a9c224e49bef573f86e3.svg";
export { ForwardRef as ReactComponent };